import { Typography, } from "@bracket/ui";
import { EthAddress, } from "@components";
import { useVaults, } from "@store";
import styled from "styled-components";



export const WalletAssocs = () => {

  const { ready, activeAdminVault: vault, } = useVaults();

  if(!ready || !vault) {
    return null;
  }

  return (
    <ContentContainer>
      <Typography variant="paragraphXL" color="var(--text-heading-title)">
        Roles
      </Typography>
      <HList $gap="2px">
				<li><Label><Typography variant="p">Vault</Typography></Label><EthAddress address={vault.address} explorer full={true} /></li>
				{
					vault.assoc_addresses.map(assoc => (
						<li key={assoc.address}>
							<Label><Typography variant="p">{assoc.name}</Typography></Label>
							<EthAddress address={assoc.address} explorer full={true} />
						</li>
					))
				}
        {/* <li><Label><Typography variant="p">Manager</Typography></Label><EthAddress address={vault.manager.address} explorer full={true} /></li> */}
        <li><Label><Typography variant="p">NAV Updater</Typography></Label><EthAddress address={vault.nav_updater_address || "unknown"} explorer full={true} /></li>
        <li><Label><Typography variant="p">Manager Claim</Typography></Label><EthAddress address={vault.manager_claim_address || "unknown"} explorer full={true} /></li>
        <li><Label><Typography variant="p">Bracket Claim</Typography></Label><EthAddress address={vault.bracket_claim_address || "unknown"} explorer full={true} /></li>
				{ Boolean(vault.wrapper) && (
					<li><Label><Typography variant="p">Wrapped</Typography></Label><EthAddress address={vault.wrapper.address} explorer full={true} /></li>
				)}
				{ Boolean(vault.morpho_url) && (
					<li><Label><Typography variant="p">Morpho</Typography></Label><a href={vault.morpho_url} target="_blank" rel="noopener noreferrer">{vault.morpho_url}</a></li>
				)}
      </HList>
    </ContentContainer>
  )
};

const ContentContainer = styled.div`
	display: grid;
	grid-template-rows: repeat(1, min-content);
	gap: 32px;
  padding: 16px 24px;
	border-radius: 8px;
	background-color: var(--surface);
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	@media (min-width: 768px) {
		grid-template-columns: 1fr;
		grid-template-rows: 1fr;
		gap: 24px;
	}
  >ul {
    list-style: none;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
    }
  }
`;

const HList = styled.ul.attrs({
  className: "h-list",
})<{ $gap?: string; }>`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap, }) => $gap || "0px" };
  li {
    display: flex;
    justify-content: unset!important;
    align-items: center;
    grid-template-columns: 1fr 1fr;
		gap: 33px;
		a {
			color: var(--primary);
			font-weight: 200;
			font-size: 14px;
		}
  }
	.address {
		font-family: "Space Mono", sans-serif;
		font-size: 14px;
		color: var(--secondary);
		font-weight: 200;
	}
`;

const Label = styled.div`
  min-width: 10rem;
`;
